<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="col-sm-12 nopads">
        <transition name="fade">
            <div
                v-if="bins.length > 0"
                class="list-content result-table"
            >
                <vue3-datatable
                    :rows="bins"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    :height="bins.length < 8 ? '100%' : '65vh'"
                    :sortable="true"
                    skin="bh-table-compact"
                    row-class="routa-table-row"
                    cell-class="routa-table-cell"
                    @row-click="rowClicked"
                >
                </vue3-datatable>
            </div>
        </Transition>
    </div>
</template>
<script>

import {timeUtils} from "@/components/mixins/TimeUtils";
import {mixedWasteBinHelper} from "@/components/mixins/MixedWasteBinMixin.js";
import Vue3Datatable from '@bhplugin/vue3-datatable'
export default {
    name: 'MixedWasteBinsList',
    components: {Vue3Datatable},
    mixins: [timeUtils, mixedWasteBinHelper],
    props: {
        mixedWasteBins: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            sortBy: 'id',
            sortDesc: false,
            bins: [],
        }
    },
    computed: {
        mixedWasteBinHelper() {
            return mixedWasteBinHelper
        },
        fields() {
            return [
                {field: 'id', title: this.$t('mixed_waste_bins.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'contracts_display', title: this.$t('orders.contract'), sort: true, headerClass: 'routa-table-header'},
                {field: 'waste_type', title: this.$t('mixed_waste_bins.waste_bin_type'), sort: true, headerClass: 'routa-table-header'},
                {field: 'identification_info', title: this.$t('mixed_waste_bins.identification_info'), sort: true, headerClass: 'routa-table-header'},
                {field: 'model', title: this.$t('mixed_waste_bins.model'), sort: true, headerClass: 'routa-table-header'},
                {field: 'size', title: this.$t('mixed_waste_bins.size'), sort: true, headerClass: 'routa-table-header', type:'number'},
                {field: 'maintainer', title: this.$t('mixed_waste_bins.maintainer'), sort: true, headerClass: 'routa-table-header'},
                {field: 'owner', title: this.$t('mixed_waste_bins.owner'), sort: true, headerClass: 'routa-table-header'},
                {field: 'holder', title: this.$t('mixed_waste_bins.holder'), sort: true, headerClass: 'routa-table-header'},
                {field: 'completion_year', title: this.$t('mixed_waste_bins.completion_year'), sort: true, headerClass: 'routa-table-header', type:'number'},
            ]
        }
    },
    watch: {
        mixedWasteBins() {
            this.bins = []
            let temp = []
            const wasteTypeList = this.getMixedWasteBinWasteType()

            this.mixedWasteBins.forEach(item => {
                let newItem = JSON.parse(JSON.stringify(item))
                const wasteFound = wasteTypeList.find(w => w.value == newItem.waste_type_id)
                newItem.waste_type =  wasteFound ? wasteFound.name : null

                if (Array.isArray(newItem.contracts) && newItem.contracts.length > 0) {
                    newItem.contracts_display = newItem.contracts
                        .map(c => c && c.name ? c.name : '')
                        .filter(n => n) // remove empty
                        .join(', ')
                }

                temp.push(newItem)
            })
            this.$nextTick(() => {
                this.bins = temp
            })
        }
    },
    methods: {
        rowClicked: function (details) {
            this.$emit('rowClicked', details)
        }
    }
}
</script>
